// extracted by mini-css-extract-plugin
module.exports = {"mainInfo":"UserInfo_mainInfo__1PJoG","userInfoLink":"UserInfo_userInfoLink__12GNb","exitInfoLink":"UserInfo_exitInfoLink__3nE6c"};